import {
  CreateResource,
  GetByIdResource,
  PutResource,
  UnpagedListResource,
  createApiResource
} from '../apiResourceFactory';
import { API } from '../apiService';
import {
  CallCenterCreateDTO,
  CallCenterDetailDTO,
  CallCenterListDTO,
  CallCenterQueryParams,
  CallCenterUpdateDTO
} from '../apiTypes.shim';

interface CallCenterResource
  extends GetByIdResource<CallCenterDetailDTO>,
    UnpagedListResource<CallCenterListDTO, CallCenterQueryParams>,
    CreateResource<CallCenterCreateDTO, CallCenterDetailDTO>,
    PutResource<CallCenterUpdateDTO, CallCenterDetailDTO> {}

export const createCallCenterResource = (): CallCenterResource => {
  const resourceUri = `call-center`;

  const {
    useGetById,
    getById,
    unpagedList,
    useUnpagedList,
    getByIdQueryKey,
    unpagedListQueryKey,
    create,
    useCreate,
    put,
    usePut
  } = createApiResource(API, resourceUri);

  return {
    useGetById,
    getById,
    unpagedList,
    useUnpagedList,
    getByIdQueryKey,
    unpagedListQueryKey,
    create,
    useCreate,
    put,
    usePut
  };
};
